/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  DeleteAttributesGlobalBody,
  DeleteAttributesLocal200,
  DeleteAttributesLocalBody,
  PostAttributesGlobalBody,
  PostAttributesLocalUpdateFromGlobal200Item,
  PostAttributesLocalUpdateFromGlobalBody,
  PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody,
  PostTablesAttributesFiltersKeys200,
  PostTablesAttributesFiltersKeysBody,
  PostTablesAttributesFiltersValues200,
  PostTablesAttributesFiltersValuesBody,
  PostTablesAttributesGraphs200,
  PostTablesAttributesGraphsBody,
  PostTablesAttributesSettingsKeys200,
  PostTablesAttributesSettingsKeysBody,
  PostTablesAttributesSettingsValues200,
  PostTablesAttributesSettingsValuesBody,
  PostTablesGlobalAttributes200,
  PostTablesGlobalAttributesBody,
  PutAttributesGlobalBody,
  PutAttributesGlobalIdBody,
  PutAttributesLocal200Item,
  PutAttributesLocalBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Deletes the global attributes table. Existing snapshots won't be affected, only new discoveries.
 * @summary Delete global attribute
 */
export const deleteAttributesGlobal = (
  deleteAttributesGlobalBody: DeleteAttributesGlobalBody,
) => {
  return apiClient<unknown>({
    url: `/attributes/global`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteAttributesGlobalBody,
  });
};

export const getDeleteAttributesGlobalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttributesGlobal>>,
    TError,
    { data: DeleteAttributesGlobalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAttributesGlobal>>,
  TError,
  { data: DeleteAttributesGlobalBody },
  TContext
> => {
  const mutationKey = ['deleteAttributesGlobal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAttributesGlobal>>,
    { data: DeleteAttributesGlobalBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteAttributesGlobal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAttributesGlobalMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAttributesGlobal>>
>;
export type DeleteAttributesGlobalMutationBody = DeleteAttributesGlobalBody;
export type DeleteAttributesGlobalMutationError = unknown;

/**
 * @summary Delete global attribute
 */
export const useDeleteAttributesGlobal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAttributesGlobal>>,
      TError,
      { data: DeleteAttributesGlobalBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAttributesGlobal>>,
  TError,
  { data: DeleteAttributesGlobalBody },
  TContext
> => {
  const mutationOptions = getDeleteAttributesGlobalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new attribute in the global attributes table
 * @summary Create global attribute
 */
export const postAttributesGlobal = (
  postAttributesGlobalBody: PostAttributesGlobalBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/attributes/global`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttributesGlobalBody,
    signal,
  });
};

export const getPostAttributesGlobalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttributesGlobal>>,
    TError,
    { data: PostAttributesGlobalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttributesGlobal>>,
  TError,
  { data: PostAttributesGlobalBody },
  TContext
> => {
  const mutationKey = ['postAttributesGlobal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttributesGlobal>>,
    { data: PostAttributesGlobalBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAttributesGlobal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAttributesGlobalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttributesGlobal>>
>;
export type PostAttributesGlobalMutationBody = PostAttributesGlobalBody;
export type PostAttributesGlobalMutationError = unknown;

/**
 * @summary Create global attribute
 */
export const usePostAttributesGlobal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAttributesGlobal>>,
      TError,
      { data: PostAttributesGlobalBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAttributesGlobal>>,
  TError,
  { data: PostAttributesGlobalBody },
  TContext
> => {
  const mutationOptions = getPostAttributesGlobalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates attributes based on filter condition
 * @summary Update attributes
 */
export const putAttributesGlobal = (
  putAttributesGlobalBody: PutAttributesGlobalBody,
) => {
  return apiClient<unknown>({
    url: `/attributes/global`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putAttributesGlobalBody,
  });
};

export const getPutAttributesGlobalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAttributesGlobal>>,
    TError,
    { data: PutAttributesGlobalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAttributesGlobal>>,
  TError,
  { data: PutAttributesGlobalBody },
  TContext
> => {
  const mutationKey = ['putAttributesGlobal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAttributesGlobal>>,
    { data: PutAttributesGlobalBody }
  > = (props) => {
    const { data } = props ?? {};

    return putAttributesGlobal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAttributesGlobalMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAttributesGlobal>>
>;
export type PutAttributesGlobalMutationBody = PutAttributesGlobalBody;
export type PutAttributesGlobalMutationError = unknown;

/**
 * @summary Update attributes
 */
export const usePutAttributesGlobal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAttributesGlobal>>,
      TError,
      { data: PutAttributesGlobalBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAttributesGlobal>>,
  TError,
  { data: PutAttributesGlobalBody },
  TContext
> => {
  const mutationOptions = getPutAttributesGlobalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates specfied attribute with attribute ID as a key
 * @summary Update specified attribute
 */
export const putAttributesGlobalId = (
  id: string,
  putAttributesGlobalIdBody: PutAttributesGlobalIdBody,
) => {
  return apiClient<unknown>({
    url: `/attributes/global/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putAttributesGlobalIdBody,
  });
};

export const getPutAttributesGlobalIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAttributesGlobalId>>,
    TError,
    { id: string; data: PutAttributesGlobalIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAttributesGlobalId>>,
  TError,
  { id: string; data: PutAttributesGlobalIdBody },
  TContext
> => {
  const mutationKey = ['putAttributesGlobalId'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAttributesGlobalId>>,
    { id: string; data: PutAttributesGlobalIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAttributesGlobalId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAttributesGlobalIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAttributesGlobalId>>
>;
export type PutAttributesGlobalIdMutationBody = PutAttributesGlobalIdBody;
export type PutAttributesGlobalIdMutationError = unknown;

/**
 * @summary Update specified attribute
 */
export const usePutAttributesGlobalId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAttributesGlobalId>>,
      TError,
      { id: string; data: PutAttributesGlobalIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAttributesGlobalId>>,
  TError,
  { id: string; data: PutAttributesGlobalIdBody },
  TContext
> => {
  const mutationOptions = getPutAttributesGlobalIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes local attributes for specified snapshot.

If **siteName** is deleted, sites, topology and reports recalculation will happen.
If other attributes are changed that are used in intent checks, only affected reports will be recalculated.

 * @summary Delete local attributes
 */
export const deleteAttributesLocal = (
  deleteAttributesLocalBody: DeleteAttributesLocalBody,
) => {
  return apiClient<DeleteAttributesLocal200>({
    url: `/attributes/local`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteAttributesLocalBody,
  });
};

export const getDeleteAttributesLocalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttributesLocal>>,
    TError,
    { data: DeleteAttributesLocalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAttributesLocal>>,
  TError,
  { data: DeleteAttributesLocalBody },
  TContext
> => {
  const mutationKey = ['deleteAttributesLocal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAttributesLocal>>,
    { data: DeleteAttributesLocalBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteAttributesLocal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAttributesLocalMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAttributesLocal>>
>;
export type DeleteAttributesLocalMutationBody = DeleteAttributesLocalBody;
export type DeleteAttributesLocalMutationError = unknown;

/**
 * @summary Delete local attributes
 */
export const useDeleteAttributesLocal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAttributesLocal>>,
      TError,
      { data: DeleteAttributesLocalBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAttributesLocal>>,
  TError,
  { data: DeleteAttributesLocalBody },
  TContext
> => {
  const mutationOptions = getDeleteAttributesLocalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates the local attributes for specified snapshot.

If **siteName** is changed, sites, topology and reports recalculation will happen.
If other attributes are changed that are used in intent checks, only affected reports will be recalculated.

 * @summary Update local attribute
 */
export const putAttributesLocal = (
  putAttributesLocalBody: PutAttributesLocalBody,
) => {
  return apiClient<PutAttributesLocal200Item[]>({
    url: `/attributes/local`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putAttributesLocalBody,
  });
};

export const getPutAttributesLocalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAttributesLocal>>,
    TError,
    { data: PutAttributesLocalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAttributesLocal>>,
  TError,
  { data: PutAttributesLocalBody },
  TContext
> => {
  const mutationKey = ['putAttributesLocal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAttributesLocal>>,
    { data: PutAttributesLocalBody }
  > = (props) => {
    const { data } = props ?? {};

    return putAttributesLocal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAttributesLocalMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAttributesLocal>>
>;
export type PutAttributesLocalMutationBody = PutAttributesLocalBody;
export type PutAttributesLocalMutationError = unknown;

/**
 * @summary Update local attribute
 */
export const usePutAttributesLocal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAttributesLocal>>,
      TError,
      { data: PutAttributesLocalBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAttributesLocal>>,
  TError,
  { data: PutAttributesLocalBody },
  TContext
> => {
  const mutationOptions = getPutAttributesLocalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update local attributes from global for specified snapshot
 * @summary Update local attributes from global
 */
export const postAttributesLocalUpdateFromGlobal = (
  postAttributesLocalUpdateFromGlobalBody: PostAttributesLocalUpdateFromGlobalBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostAttributesLocalUpdateFromGlobal200Item[]>({
    url: `/attributes/local/update-from-global`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttributesLocalUpdateFromGlobalBody,
    signal,
  });
};

export const getPostAttributesLocalUpdateFromGlobalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttributesLocalUpdateFromGlobal>>,
    TError,
    { data: PostAttributesLocalUpdateFromGlobalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttributesLocalUpdateFromGlobal>>,
  TError,
  { data: PostAttributesLocalUpdateFromGlobalBody },
  TContext
> => {
  const mutationKey = ['postAttributesLocalUpdateFromGlobal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttributesLocalUpdateFromGlobal>>,
    { data: PostAttributesLocalUpdateFromGlobalBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAttributesLocalUpdateFromGlobal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAttributesLocalUpdateFromGlobalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttributesLocalUpdateFromGlobal>>
>;
export type PostAttributesLocalUpdateFromGlobalMutationBody =
  PostAttributesLocalUpdateFromGlobalBody;
export type PostAttributesLocalUpdateFromGlobalMutationError = unknown;

/**
 * @summary Update local attributes from global
 */
export const usePostAttributesLocalUpdateFromGlobal = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAttributesLocalUpdateFromGlobal>>,
      TError,
      { data: PostAttributesLocalUpdateFromGlobalBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAttributesLocalUpdateFromGlobal>>,
  TError,
  { data: PostAttributesLocalUpdateFromGlobalBody },
  TContext
> => {
  const mutationOptions =
    getPostAttributesLocalUpdateFromGlobalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Check if attributes update will trigger sites recalculation for specified snapshot
 * @summary Check if attributes update will trigger sites recalculation
 */
export const postAttributesLocalUpdateFromGlobalCheckSitesRecalculation = (
  postAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody: PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/attributes/local/update-from-global/check-sites-recalculation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody,
    signal,
  });
};

export const getPostAttributesLocalUpdateFromGlobalCheckSitesRecalculationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postAttributesLocalUpdateFromGlobalCheckSitesRecalculation
        >
      >,
      TError,
      { data: PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postAttributesLocalUpdateFromGlobalCheckSitesRecalculation
      >
    >,
    TError,
    { data: PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody },
    TContext
  > => {
    const mutationKey = [
      'postAttributesLocalUpdateFromGlobalCheckSitesRecalculation',
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postAttributesLocalUpdateFromGlobalCheckSitesRecalculation
        >
      >,
      { data: PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody }
    > = (props) => {
      const { data } = props ?? {};

      return postAttributesLocalUpdateFromGlobalCheckSitesRecalculation(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postAttributesLocalUpdateFromGlobalCheckSitesRecalculation
      >
    >
  >;
export type PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationMutationBody =
  PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody;
export type PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationMutationError =
  unknown;

/**
 * @summary Check if attributes update will trigger sites recalculation
 */
export const usePostAttributesLocalUpdateFromGlobalCheckSitesRecalculation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postAttributesLocalUpdateFromGlobalCheckSitesRecalculation
        >
      >,
      TError,
      { data: PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postAttributesLocalUpdateFromGlobalCheckSitesRecalculation
    >
  >,
  TError,
  { data: PostAttributesLocalUpdateFromGlobalCheckSitesRecalculationBody },
  TContext
> => {
  const mutationOptions =
    getPostAttributesLocalUpdateFromGlobalCheckSitesRecalculationMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary POST /tables/attributes/filters/keys
 */
export const postTablesAttributesFiltersKeys = (
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesAttributesFiltersKeys200>({
    url: `/tables/attributes/filters/keys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesAttributesFiltersKeysBody,
    signal,
  });
};

export const getPostTablesAttributesFiltersKeysQueryKey = (
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
) => {
  return [
    `/tables/attributes/filters/keys`,
    postTablesAttributesFiltersKeysBody,
  ] as const;
};

export const getPostTablesAttributesFiltersKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
  TError = unknown,
>(
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesAttributesFiltersKeysQueryKey(
      postTablesAttributesFiltersKeysBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>
  > = ({ signal }) =>
    postTablesAttributesFiltersKeys(
      postTablesAttributesFiltersKeysBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesAttributesFiltersKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>
>;
export type PostTablesAttributesFiltersKeysQueryError = unknown;

export function usePostTablesAttributesFiltersKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
  TError = unknown,
>(
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesFiltersKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
  TError = unknown,
>(
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesFiltersKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
  TError = unknown,
>(
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/attributes/filters/keys
 */

export function usePostTablesAttributesFiltersKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
  TError = unknown,
>(
  postTablesAttributesFiltersKeysBody: PostTablesAttributesFiltersKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersKeys>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesAttributesFiltersKeysQueryOptions(
    postTablesAttributesFiltersKeysBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/attributes/filters/values
 */
export const postTablesAttributesFiltersValues = (
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesAttributesFiltersValues200>({
    url: `/tables/attributes/filters/values`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesAttributesFiltersValuesBody,
    signal,
  });
};

export const getPostTablesAttributesFiltersValuesQueryKey = (
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
) => {
  return [
    `/tables/attributes/filters/values`,
    postTablesAttributesFiltersValuesBody,
  ] as const;
};

export const getPostTablesAttributesFiltersValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
  TError = unknown,
>(
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesAttributesFiltersValuesQueryKey(
      postTablesAttributesFiltersValuesBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>
  > = ({ signal }) =>
    postTablesAttributesFiltersValues(
      postTablesAttributesFiltersValuesBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesAttributesFiltersValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>
>;
export type PostTablesAttributesFiltersValuesQueryError = unknown;

export function usePostTablesAttributesFiltersValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
  TError = unknown,
>(
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesFiltersValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
  TError = unknown,
>(
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesFiltersValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
  TError = unknown,
>(
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/attributes/filters/values
 */

export function usePostTablesAttributesFiltersValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
  TError = unknown,
>(
  postTablesAttributesFiltersValuesBody: PostTablesAttributesFiltersValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesFiltersValues>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesAttributesFiltersValuesQueryOptions(
    postTablesAttributesFiltersValuesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/attributes/graphs
 */
export const postTablesAttributesGraphs = (
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesAttributesGraphs200>({
    url: `/tables/attributes/graphs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesAttributesGraphsBody,
    signal,
  });
};

export const getPostTablesAttributesGraphsQueryKey = (
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
) => {
  return [`/tables/attributes/graphs`, postTablesAttributesGraphsBody] as const;
};

export const getPostTablesAttributesGraphsQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
  TError = unknown,
>(
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesAttributesGraphsQueryKey(postTablesAttributesGraphsBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesAttributesGraphs>>
  > = ({ signal }) =>
    postTablesAttributesGraphs(postTablesAttributesGraphsBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesAttributesGraphsQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesAttributesGraphs>>
>;
export type PostTablesAttributesGraphsQueryError = unknown;

export function usePostTablesAttributesGraphs<
  TData = Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
  TError = unknown,
>(
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesGraphs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesGraphs<
  TData = Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
  TError = unknown,
>(
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesGraphs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesGraphs<
  TData = Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
  TError = unknown,
>(
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/attributes/graphs
 */

export function usePostTablesAttributesGraphs<
  TData = Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
  TError = unknown,
>(
  postTablesAttributesGraphsBody: PostTablesAttributesGraphsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesGraphs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesAttributesGraphsQueryOptions(
    postTablesAttributesGraphsBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/attributes/settings/keys
 */
export const postTablesAttributesSettingsKeys = (
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesAttributesSettingsKeys200>({
    url: `/tables/attributes/settings/keys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesAttributesSettingsKeysBody,
    signal,
  });
};

export const getPostTablesAttributesSettingsKeysQueryKey = (
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
) => {
  return [
    `/tables/attributes/settings/keys`,
    postTablesAttributesSettingsKeysBody,
  ] as const;
};

export const getPostTablesAttributesSettingsKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
  TError = unknown,
>(
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesAttributesSettingsKeysQueryKey(
      postTablesAttributesSettingsKeysBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>
  > = ({ signal }) =>
    postTablesAttributesSettingsKeys(
      postTablesAttributesSettingsKeysBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesAttributesSettingsKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>
>;
export type PostTablesAttributesSettingsKeysQueryError = unknown;

export function usePostTablesAttributesSettingsKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
  TError = unknown,
>(
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesSettingsKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
  TError = unknown,
>(
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesSettingsKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
  TError = unknown,
>(
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/attributes/settings/keys
 */

export function usePostTablesAttributesSettingsKeys<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
  TError = unknown,
>(
  postTablesAttributesSettingsKeysBody: PostTablesAttributesSettingsKeysBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsKeys>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesAttributesSettingsKeysQueryOptions(
    postTablesAttributesSettingsKeysBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/attributes/settings/values
 */
export const postTablesAttributesSettingsValues = (
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesAttributesSettingsValues200>({
    url: `/tables/attributes/settings/values`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesAttributesSettingsValuesBody,
    signal,
  });
};

export const getPostTablesAttributesSettingsValuesQueryKey = (
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
) => {
  return [
    `/tables/attributes/settings/values`,
    postTablesAttributesSettingsValuesBody,
  ] as const;
};

export const getPostTablesAttributesSettingsValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
  TError = unknown,
>(
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesAttributesSettingsValuesQueryKey(
      postTablesAttributesSettingsValuesBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>
  > = ({ signal }) =>
    postTablesAttributesSettingsValues(
      postTablesAttributesSettingsValuesBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesAttributesSettingsValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>
>;
export type PostTablesAttributesSettingsValuesQueryError = unknown;

export function usePostTablesAttributesSettingsValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
  TError = unknown,
>(
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesSettingsValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
  TError = unknown,
>(
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
          TError,
          Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesAttributesSettingsValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
  TError = unknown,
>(
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/attributes/settings/values
 */

export function usePostTablesAttributesSettingsValues<
  TData = Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
  TError = unknown,
>(
  postTablesAttributesSettingsValuesBody: PostTablesAttributesSettingsValuesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesAttributesSettingsValues>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesAttributesSettingsValuesQueryOptions(
    postTablesAttributesSettingsValuesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Global attributes inventory
 * @summary Global Attributes
 */
export const postTablesGlobalAttributes = (
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesGlobalAttributes200>({
    url: `/tables/global-attributes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesGlobalAttributesBody,
    signal,
  });
};

export const getPostTablesGlobalAttributesQueryKey = (
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
) => {
  return [`/tables/global-attributes`, postTablesGlobalAttributesBody] as const;
};

export const getPostTablesGlobalAttributesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
  TError = unknown,
>(
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesGlobalAttributesQueryKey(postTablesGlobalAttributesBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesGlobalAttributes>>
  > = ({ signal }) =>
    postTablesGlobalAttributes(postTablesGlobalAttributesBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesGlobalAttributesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesGlobalAttributes>>
>;
export type PostTablesGlobalAttributesQueryError = unknown;

export function usePostTablesGlobalAttributes<
  TData = Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
  TError = unknown,
>(
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
          TError,
          Awaited<ReturnType<typeof postTablesGlobalAttributes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesGlobalAttributes<
  TData = Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
  TError = unknown,
>(
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
          TError,
          Awaited<ReturnType<typeof postTablesGlobalAttributes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesGlobalAttributes<
  TData = Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
  TError = unknown,
>(
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Global Attributes
 */

export function usePostTablesGlobalAttributes<
  TData = Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
  TError = unknown,
>(
  postTablesGlobalAttributesBody: PostTablesGlobalAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesGlobalAttributes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesGlobalAttributesQueryOptions(
    postTablesGlobalAttributesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
